//spec codes
export const PRINTED_SIDE_CODE = 'PS';
export const PRINTED_SIDE_VALUE_CODES = ['1', '01', '2'];
export const SIZE_CODE = 'SZ';
export const SWAG_PRODUCT_CODE = 'SW';
export const SWAG_PRODUCT_VALUE_CODE = 'YES';
export const S_COLOR_CODE = 'CL';
export const S_INK_COLOR_CODE = 'ICL';
export const BACKLIT_CODE = 'BKL';
export const BACKLIT_VALUE_CODES = ['YES', 'NO'];
export const S_BASE = 'BASE';
export const S_QTY_CODE = 'QT';
export const S_CO_BRANDING = 'COB';
export const S_CO_BRANDING_VALUES = ['YES', 'NO'];
export const MATERIAL_S_CODE = 'MT';
export const PACKAGE_S_V_CODES = ['F', 'GF'];

export const NOT_SECONDE_SURFACE = 'NOT_SECONDE_SURFACE';
export const HIDDEN_BACK_SIDE_NAME = 'back';
export const SECTION_BODY = 'body';
export const RESET_CAMERA = 'RESET_CAMERA';
export const SWAG_PRODUCT_D_N_NAME = 'designable';

//S3 bucket folders
export const BUNDLE_PRODUCT_TEXTURES = 'BUNDLE_PRODUCT_TEXTURES';
export const PATTERN_SETS = 'PATTERN_SETS';
export const ADS = 'ADS';

export const TENT_ADS = {
  ex: 'expo-tent-ads.jpg',
  mi: 'milo-tent-ads.jpg',
  vt: 'vivid-tent-ads.jpg',
  ap: 'ap-tent-ads.jpg',
};
